import { CourseSkillLevel } from "@/lib/constants";
import { Platform, type TextStyle } from "react-native";

export const RECENT_KEY = "global-search-recent-v1";
export const MAX_RECENT = 5;
export const MIN_SEARCH_QUERY_LENGTH = 2;
export const SEARCH_DEBOUNCE_MS = 400;
export const SEARCH_RESULTS_LIMIT = 1000;

export const TRENDING_TOPIC_LABELS = [
  "Jazz Piano For Beginners",
  "Harmony Games",
  "Ear Training",
  "Bebop",
  "Stevie Wonder",
  "Keezer",
  "Beginner Jazz",
  "GPS",
  "Comping",
] as const;

export const SEARCH_RESULT_L1_SHADOW =
  Platform.OS === "web"
    ? {
        boxShadow:
          "0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.08)",
      }
    : {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.12,
        shadowRadius: 4,
        elevation: 4,
      };

export const SEARCH_THUMB_COL_WIDTH_MOBILE = 148;
export const SEARCH_THUMB_COL_WIDTH_SM_UP = 212;
export const SEARCH_THUMB_PROGRESS_H = 2;
export const SEARCH_RESULT_THUMB_ASPECT = 16 / 9;

export const SEARCH_RESULT_BADGE_BASE: TextStyle = {
  paddingHorizontal: 6,
  paddingVertical: 2,
  borderRadius: 4,
  overflow: "hidden",
  fontSize: 10,
  lineHeight: 12,
  fontWeight: "600",
  textTransform: "uppercase",
  color: "#0D0D0D",
};

/** Warm stone — full courses */
export const SEARCH_BADGE_COURSE_BG = "rgba(244, 241, 237, 1)";
export const SEARCH_BADGE_LESSON_BG = "rgba(227, 242, 251, 1)";
/** Cool sage — distinct from course greige at a glance */
export const SEARCH_BADGE_COLLECTION_BG = "rgba(214, 232, 220, 1)";

export const LEVEL_ORANGE = "rgba(242, 102, 58, 1)";
/** Level bar stroke (Figma Surface-Alt-3-6) */
export const LEVEL_INDICATOR_ACTIVE = "#E17100";
export const LEVEL_BAR_GRAY = "#D2CCC5";
/** Inactive bar in level icon (Figma Content-Accent-2) */
export const LEVEL_ICON_STROKE_INACTIVE = "#5C5854";
/** LEVELS dropdown panel (Figma Overlay-Filter-Level) */
export const SKILL_LEVEL_PANEL_WIDTH = 212;
export const SKILL_LEVEL_PANEL_MAX_HEIGHT = 216;

export const SKILL_TIERS: CourseSkillLevel[] = [
  CourseSkillLevel.Beginner,
  CourseSkillLevel.Intermediate,
  CourseSkillLevel.Advanced,
];

export type TierPickState = Record<CourseSkillLevel, boolean>;

export const DEFAULT_TIER_PICK: TierPickState = {
  [CourseSkillLevel.Beginner]: false,
  [CourseSkillLevel.Intermediate]: false,
  [CourseSkillLevel.Advanced]: false,
};
